import { useRuntimeConfig } from "#imports";
import { getCookie, getQuery } from "h3";
import { getRequestMarket } from "@backmarket/nuxt-module-marketplace/getRequestMarket";
import { toBcp47Locale } from "@backmarket/utils/string/toBcp47Locale";
import { COOKIE_LANGUAGE } from "../constants.js";
import { getLocaleFromAcceptLanguage } from "./getLocaleFromAcceptLanguage.js";
import { getLocaleFromPath } from "./getLocaleFromPath.js";
export function getRequestLocale(event) {
  const market = getRequestMarket(event);
  const query = getQuery(event);
  if (event.path?.startsWith("/__nuxt_error") && query.error === "true") {
    const originalUrl = query.url?.toString();
    if (originalUrl) {
      const localeFromPath2 = getLocaleFromPath(originalUrl);
      const supportedLocales2 = market.locales?.map(toBcp47Locale) ?? [];
      if (localeFromPath2 && supportedLocales2.includes(localeFromPath2)) {
        return localeFromPath2;
      }
    }
  }
  const localeFromPath = getLocaleFromPath(event.path);
  if (localeFromPath) return toBcp47Locale(localeFromPath);
  const runtimeConfig = useRuntimeConfig(event);
  const { localeFromCookie } = runtimeConfig.public.i18nLocale;
  if (localeFromCookie) {
    const cookieLocale = getCookie(event, COOKIE_LANGUAGE);
    if (cookieLocale) return toBcp47Locale(cookieLocale);
  }
  const headerLocale = getLocaleFromAcceptLanguage(event);
  const supportedLocales = market.locales.map(toBcp47Locale);
  if (headerLocale && supportedLocales.includes(headerLocale)) {
    return headerLocale;
  }
  return toBcp47Locale(market.defaultLocale);
}
